export default __webpack_public_path__ + "images/download.f74185b6dc19ac7a538ec6044b690e59.svg";